import moment from 'moment';

export default class UpdateAgentTaskRead {
  constructor(context) {
    this.context = context;
  }

  run(taskId) {
    const agentId = this.context.stores.currentAgent.get().id;
    const readAt = moment().toISOString();

    const agentTaskRead = {
      agentId,
      taskId,
      readAt,
    };

    this.context.gateways.agentTaskRead.update(agentTaskRead);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/task/update_agent_task_read.js